import(/* webpackMode: "eager", webpackExports: ["NavigationEvents"] */ "/vercel/path0/app/components/navigation-events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ProviderLayout.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.scss");
